import { FocusEventHandler, useCallback, useState } from 'react';

export function useIsFocused<TFocusTarget>(
  options: UseIsFocusedOptions<TFocusTarget>
): {
  handleFocus: FocusEventHandler<TFocusTarget>;
  handleBlur: FocusEventHandler<TFocusTarget>;
  isFocused: boolean;
} {
  const { onBlur, onFocus } = options;
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus: FocusEventHandler<TFocusTarget> = useCallback(
    (event) => {
      onFocus?.(event);
      setIsFocused(true);
    },
    [setIsFocused, onFocus]
  );

  const handleBlur: FocusEventHandler<TFocusTarget> = useCallback(
    (event) => {
      onBlur?.(event);
      setIsFocused(false);
    },
    [setIsFocused, onBlur]
  );

  return { isFocused, handleFocus, handleBlur };
}

export type UseIsFocusedOptions<TFocusTarget> = {
  /**
   * event handler to call on focus
   */
  onFocus?: FocusEventHandler<TFocusTarget>;

  /**
   * event handler to call on blur
   */
  onBlur?: FocusEventHandler<TFocusTarget>;
};
